export const PLAYING_STATUS = "PLAYING";
export const PAUSE_STATUS = "PAUSE";
export const LOADING_STATUS = "LOADING";

export const PLAY_EVENT = "play";
export const PLAYING_EVENT = "playing";
export const SEEKED_EVENT = "seeked";
export const PAUSE_EVENT = "pause";
export const WAITING_EVENT = "waiting";
export const TIMEUPDATE_EVENT = "timeupdate";
export const VOLUMECHANGE_EVENT = "volumechange";
export const LOADEDMETADATA_EVENT = "loadedmetadata";
export const PROGRESS_EVENT = "progress";
